// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"745bed5a","239":"9f6d6293","453":"3266dcdb","455":"5fe6af4c"}[chunkId] + ".chunk.js";
};